import { create } from 'zustand'

export const useSidebarStorage = create((set) => ({
    isCollapsed: true,
    scrollPosition: 0,
    expandedItemIds: [],

    setSidebarState: (state) => {
        set((currentState) => ({
            ...currentState,
            ...(state.isCollapsed !== undefined && { isCollapsed: state.isCollapsed }),
            ...(state.scrollPosition !== undefined && { scrollPosition: state.scrollPosition }),
            ...(state.expandedItemIds !== undefined && {
                expandedItemIds: Array.isArray(state.expandedItemIds)
                    ? state.expandedItemIds
                    : []
            })
        }));
    },

    setCollapsed: (isCollapsed) => {
        set({ isCollapsed });
    },

    setScrollPosition: (scrollPosition) => {
        set({ scrollPosition });
    },

    setExpandedItemIds: (expandedItemIds) => {
        set({ expandedItemIds: Array.isArray(expandedItemIds) ? expandedItemIds : [] });
    },

    toggleExpanded: (itemId) => {
        set((state) => {
            const newExpandedItemIds = [...state.expandedItemIds];
            const index = newExpandedItemIds.indexOf(itemId);
            if (index > -1) {
                newExpandedItemIds.splice(index, 1);
            } else {
                newExpandedItemIds.push(itemId);
            }
            return { expandedItemIds: newExpandedItemIds };
        });
    }
}));
